/**
 * Registry mapping provedor type keys to their AbasDataType arrays.
 *
 * To support a new provedor type (e.g. provedor_validacao):
 *   1. Create AbasDataTypeValidacao.js with the field definitions
 *   2. Import it here and add one entry: provedor_validacao: AbasDataTypeValidacao
 *
 * No changes needed in AbaComponent or FichaTecnicaTarefaPage.
 */
import { AbasDataType } from './AbasDataType'
import { AbasDataTypeInstalacao } from './AbasDataTypeInstalacao'

export const AbasDataTypeRegistry = {
  provedor_recuperacao: AbasDataType,
  provedor_instalacao: AbasDataTypeInstalacao,
}

/**
 * Returns the AbasDataType array for the given provedor type key.
 * Falls back to an empty array if the type is not registered.
 * @param {string|null} tipo - e.g. 'provedor_recuperacao'
 * @returns {Array}
 */
export const getAbasDataType = (tipo) => {
  return AbasDataTypeRegistry[tipo] ?? []
}
